

export const filterFieldsConfig = [
    { key: "search", labelKey: "searchLabel", type: "input" },
    {
        key: "status",
        labelKey: "statusLabel",
        type: "dropdown",
        options: [
            { value: '', labelKey: 'all' },
            { value: 'ACTIVE', labelKey: 'active' },
            { value: 'BLOCKED', labelKey: 'blocked' },
        ],
    },
];